import { useQuery } from "@tanstack/react-query";
import { ISalesSummaryReport } from "src/types/reports";
import { QueryParamValue, toQueryString } from "src/utils";
import apiFastifyClient from "./apiFastifyCloud";

interface IParams {
  startDate?: number;
  endDate?: number;
  locations?: string[];
  services?: string[];
  serviceType?: string;
  serviceName?: string;
}

export const useGetSalesSummary = (params: IParams) =>
  useQuery<IParams, any, { data: ISalesSummaryReport }>({
    queryKey: [
      "get-sales-summary",
      params.startDate,
      params.endDate,
      params.locations,
      params.serviceType,
      params.serviceName,
    ],
    queryFn: async () => {
      const queryString = toQueryString(
        params as Record<string, QueryParamValue>,
      );
      return apiFastifyClient.get(
        `/v1/transactions/reports/sales-summary?${queryString}`,
      );
    },
    enabled: !!params.startDate && !!params.endDate,
    gcTime: 1 * 60 * 60 * 1000, // 1 Hour
  });

export const useGetClientLocationsServices = () =>
  useQuery<IParams, any, { data: any[] }>({
    queryKey: ["get-client-locations-services"],
    queryFn: async () => {
      return apiFastifyClient.get(
        `/v1/transactions/reports/client-location-services`,
      );
    },
    gcTime: 30 * 60 * 1000, // 0.5 Hour
  });
